<script>
   /*************************************************************/
   /* AppPlots global component for plots routing               */
   /* -------------------------------------------               */
   /* show list of plots and let user to select one, and        */
   /* interact with it.                                         */
   /*************************************************************/


   // import control components
   import { Widget } from 'svelte-controls-basic';

   let {
      plots,                  // JSON with plot components, labels and scope
      props,                  // JSON with main properties, including model, dataset and results
      controls,               // JSON with plot controls as Widget properties
      selobjText = 'Click to select an object...',
      selvarText = 'Make rectangular selection of variable to exclude ...',
      clearText = 'Click anywhere to remove selection...',
      params = $bindable(),   // array with JSONs containing selObject plot parameters
   } = $props();


   // app state parameters (objects are selected individually, variables - as array)
   let selItems = $state({objects: -1, variables: []});
   let selPlotId = $state(Object.keys(plots)[0]);

   // mark object as selected
   function selectObject(ind) {
      selItems.objects = ind;
   }

   // remove the selection
   function unselectObject(ind) {
      selItems.objects = -1;
   }

   // mark variable as selected
   function selectVariable(ind) {
      selItems.variables = ind;
   }

   // remove the selection
   function unselectVariable(ind) {
      selItems.variables = [];
   }

   // callbacks for each scope
   let appCallbacks = {
      objects: {select: selectObject, unselect: unselectObject},
      variables: {select: selectVariable, unselect: unselectVariable},
      stats: {}
   };

   // derived elements
   let selPlot = $derived(selPlotId ? plots[selPlotId] : null);      // selected plot
   let PlotComponent = $derived(selPlot ? selPlot.component : null); // selected plot component
</script>

<div class="plot-panel">

   <!-- column with current plot -->
   <div class="plot-area">
      <div class="plot">
      <PlotComponent
         params={params[selPlotId]}
         callbacks={appCallbacks[selPlot.scope]}
         selected={selItems[selPlot.scope]}
         {props}
      />
      </div>
      <div class="plot-select-msg">
      {#if selPlot.scope === 'objects' && params[selPlotId].plotType !== 'l' && selobjText.length > 0}
         {#if selItems[selPlot.scope] < 0}
         <div class="msg-select">{selobjText}</div>
         {:else}
         <div class="msg-select">{clearText}</div>
         {/if}
      {/if}
      {#if selPlot.scope === 'variables' && params[selPlotId].plotType !== 'l' && selvarText.length > 0}
         {#if selItems[selPlot.scope].length === 0}
         <div class="msg-select">{selvarText}</div>
         {:else}
         <div class="msg-select">{clearText}</div>
         {/if}
      {/if}
      </div>
   </div>

   <!-- column with plot selectors and current plot settings -->
   <div class="plot-controls-area">
      {#each Object.keys(plots) as plotId}

         {#if selPlot && selPlotId === plotId}

            <Widget title={selPlot.label} labelWidth={12} options={controls[selPlotId]} bind:value={params[selPlotId]}/>

            {#if selPlot.scope === 'objects' && selPlot.buttons && selItems.objects >= 0}
            <div class="selected-buttons">
            {@render selPlot.buttons(selItems.objects)}
            </div>
            {/if}

            {#if selPlot.scope === 'variables' && selPlot.buttons && selItems.variables.length > 0}
            <div class="selected-buttons">
            {@render selPlot.buttons(selItems.variables)}
            </div>
            {/if}

         {:else}
         <button class="plot-selector plot-selector-{plotId}" onkeydown={() => switchPlot(i)} onclick={() => selPlotId = plotId}>{plots[plotId].label}</button>
         {/if}
      {/each}

   </div>
</div>


<style>
   .selected-buttons > :global(.control-element) {
      background: #fff0c8;
   }

   .selected-buttons > :global(.control-element button:last-of-type) {
      color: white;
      border-color: crimson;
      background: crimson;
      margin-left: 5px;
   }

   .selected-buttons > :global(.control-element button:last-of-type:hover) {
      background: #DC143C20;
      border-color: #DC143C80;
      color: crimson;
   }

   .plot-panel {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 1fr minmax(270px, 30%);
   }

   .plot-area {
      padding: 1em;
      margin-top: 0.25rem;
      border-radius: 0.25em;
      background: #fefefe;
   }

   .plot-controls-area {
      padding: 0 0.25em 0 0.5em;
   }

   .plot-selector {
      cursor: pointer;
      color: #606060;
      background: #fffef480;
      box-sizing: border-box;
      padding: 0.5em 1em;
      margin: 0.25em 0;
      border-radius: 0.25rem;
      box-shadow: none;
      border: none;
      width: 100%;
      text-align: left;
      font-size: 1rem;
   }

   .plot-selector:hover {
      background: #e0e0e0;
      color: #403020;
   }

   :global(div.plot-container.off-screen) {
      position:absolute;
      top:0;
      left:50%;
      width: 650px;
      height: 600px;
      background: white;
      z-index: 999;
   }

   .plot {
      width: 100%;
      height: calc(100% - 15px);
   }

   .plot-select-msg {
      height: 15px;
      font-size: 12px;
      color: #aaa;
      text-align: center;
   }


   @media(min-width:1100px) {
      .plot-panel {
         grid-template-columns: 1fr minmax(285px, 30%);
      }
   }

   @media(min-width:1300px) {
      .plot-panel {
         grid-template-columns: 1fr max(300px, 30%);
      }
   }

   @media(min-width:1600px) {
      .plot-panel {
         grid-template-columns: 1fr 400px;
      }
   }

</style>